import Affair from '@/models/Affair';

export default class Station {
  public id: string = '';
  public name: string = '';
  public affairs: Affair[] = [];

  constructor(id: string = '', name: string = '', affairs: Affair[] = []) {
    this.id = id;
    this.name = name;
    this.affairs = affairs;
  }
}
